<template>
  <div
    class="ui-toast"
    :class="classList"
    @click="remove">
    <div class="toast-icon">
      <i :class="iconClass"></i>
    </div>
    <div class="toast-message">
      {{ item.message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UiToast',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    remove() {
      this.$emit('remove', this.item.id);
    },
  },

  computed: {
    classList() {
      return {
        default: this.item.type === 'default',
        success: this.item.type === 'success',
        info: this.item.type === 'info',
        warning: this.item.type === 'warning',
        error: this.item.type === 'error',
      };
    },
    iconClass() {
      switch (this.item.type) {
        case 'success':
          return 'fa-solid fa-check-circle';
        case 'info':
          return 'fa-solid fa-info-circle';
        case 'warning':
          return 'fa-solid fa-exclamation-circle';
        case 'error':
          return 'fa-solid fa-times-circle';
        default:
          return 'fa-solid fa-comment';
      }
    },
  },

  mounted() {
    if (this.item.duration) {
      const timer = setTimeout(() => {
        clearTimeout(timer);
        this.remove();
      }, this.item.duration);
    }
  },
};
</script>

<style lang="scss">
.ui-toast {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  padding: 15px 20px;
  margin: 10px 0;
  border-radius: 8px;
  background-color: #fff; /* White background */
  font-size: 14px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, opacity 0.3s ease;

  &.default {
    color: #333; /* Neutral text color */
    border-left: 5px solid #ccc;
  }
  &.success {
    color: #28a745; /* Green text for success */
    border-left: 5px solid #28a745;
  }
  &.info {
    color: #007bff; /* Blue text for info */
    border-left: 5px solid #007bff;
  }
  &.warning {
    color: #ffc107; /* Orange text for warning */
    border-left: 5px solid #ffc107;
  }
  &.error {
    color: #dc3545; /* Red text for error */
    border-left: 5px solid #dc3545;
  }

  .toast-icon {
    font-size: 18px;
  }

  .toast-message {
    flex: 1;
    font-weight: 500;
  }

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15), 0 3px 5px rgba(0, 0, 0, 0.1);
  }
}
</style>
